module.exports = __webpack_public_path__ + "img/international_flights_small@2x.e6e975a8.jpg";